module.exports = __webpack_public_path__ + "static/media/reencoding_shutterstock_videos_x1small.ac4d8c0f.mp4";